<template>
    <div class="file-input-container">
        <label
            class="file-input"
            @dragover.prevent
            @drop.prevent="uploadPhoto($event)"
            @dragenter.prevent="$event.target.classList.add('dragover')"
            @dragleave.prevent="$event.target.classList.remove('dragover')"
        >
            <input
                type="file"
                @change="uploadPhoto($event)"
            >
            <span>
                {{ label }}
            </span>

        </label>
        <div
            class="preview-container"
            v-if="preview"
        >
            <div
                :class="{'uploading' : progress < 100
                        && checkType(value) === 'File'}"
                class="preview image-preview"
                :style="value ? `background-image: url(${preview})`: ''"
                v-if="preview.split('.').pop() !== 'mp4'"
            >
            </div>

            <video
                v-else
                class="preview"
                autoplay
                loop
            >
                <source :src="value">
            </video>

            <div
                class="progress"
                v-if="checkType(value) === 'File'"
            >
                <div
                    class="bar"
                    :style="`width: ${progress}%;`"
                >
                </div>
            </div>

            <span>
                {{ fileName }}
            </span>

            <img
                src="@/assets/icons/ic_delete.svg"
                class="remove"
                @click="remove()"
            >
        </div>
    </div>
</template>

<script>
export default {
	props: {
		value: {
			type: File || Object,
			default: () => {}
		},

		label: {
			type: String,
			default: ''
		},

		isLoading: {
			type: Boolean,
			default: false
		},

		progress: {
			type: Number,
			default: 10
		},

		allowedExtensions: {
			type: Array,
			default: () => []
		}
	},

	data () {
		return {
			fileName: ''
		}
	},

	computed: {
		preview () {
			return this.checkType(this.value) === 'File' ? this.value.name : this.value
		}
	},

	methods: {
		uploadPhoto (e) {
			const MAX_IMAGE_SIZE = 5000000
			const MAX_VIDEO_SIZE = 25000000

			e.target.classList.remove('dragover')

			let file = e.target.files || e.dataTransfer.files

			if (file && file[0]) {
				const FILE_TYPE = file[0]['type'].split('/')[0]

				if (
					this.allowedExtensions.length > 0 &&
                    !this.isFile(file[0], this.allowedExtensions)
				) {
					this.$emit('warning', 'Invalid file type.')
					return
				}

				if (FILE_TYPE === 'image' && file[0].size > MAX_IMAGE_SIZE) {
					this.$emit('warning', 'Image size must be 5MB or below.')
					return
				}

				if (FILE_TYPE === 'video' && file[0].size > MAX_VIDEO_SIZE) {
					this.$emit('warning', 'Image size must be 25MB or below.')
					return
				}

				this.fileName = file[0].name
				this.$emit('input', file[0])

				setTimeout(() => {
					this.setPreview(file[0], FILE_TYPE)
				}, 0)
			}

			e.target.type = 'text'
			e.target.type = 'file'
		},

		remove () {
			let output = this.$el.querySelector('.preview')
			output.style.backgroundImage = ''

			this.$emit('remove')
		},

		setPreview (file, type) {
			if (type === 'image') {
				const reader = new FileReader()

				reader.onload = () => {
					let output = this.$el.querySelector('.image-preview')
					output.style.backgroundImage = `url('${reader.result}')`
				}

				reader.readAsDataURL(file)
			}

			if (type === 'video') {
				this.$el.querySelector('video source').setAttribute('src', URL.createObjectURL(file))
				this.$el.querySelector('video').load()
			}
		},

		checkType (variable) {
			if (!variable) return false

			return Object.prototype.toString.call(variable).slice(8, -1)
		},

		isFile (variable, ext) {
			if (!variable) return false

			if (this.checkType(variable) !== 'File') return false

			if (ext && !this.hasExtension(variable, ext)) return false

			return true
		},

		hasExtension (variable, ext) {
			if (!(!!ext.indexOf && variable)) return false

			let extension = variable.name.split('.').pop()
			return ext.indexOf(extension) > -1
		}
	}
}
</script>

<style lang="scss" scoped>
.file-input-container {
    position: relative;

    label.file-input {
        height: 100%;
        width: 100%;
        position: relative;
        display: block;
        border: 1px dashed #999;
        text-align: center;
        cursor: pointer;

        &.dragover, &:hover {
            box-shadow: inset 0 0 10px #aaa;
        }

        input {
            position: absolute;
            width: 0;
            height: 0;
            opacity: 0;
        }

        span {
            display: flex;
            width: 100%;
            height: 100%;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            padding: 10px;
            font-size: 14px;
        }
    }

    .preview-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
        pointer-events: none;
        background-color: #FDFEFF;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 15px;
        border: 1px dashed #999;

        .preview {
            flex: 1 1 auto;
            height: 100%;
            max-height: 125px;
            width: 85%;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            background-color: #fff;
            border: 1px solid #ddd;
            margin-bottom: 10px;

            &.uploading {
                opacity: 0.7;
            }
        }

        video.preview {
            background-color: #000;
        }

        .progress {
            margin-bottom: 10px;
            height: 5px;
            width: 50%;
            border: 1px solid #2DC4B6;
            border-radius: 3px;
            padding: 0;
            position: relative;

            .bar {
                position: absolute;
                top: 0;
                left: 0;
                display: inline-block;
                height: 100%;
                background-color: #2DC4B6;
                transition: 0.3s;
            }
        }

        span {
            margin: 0;
            text-align: center;
            font-size: 13px;
        }

        .remove {
            width: 15px;
            height: 15px;
            position: absolute;
            top: 10px;
            right: 10px;
            pointer-events: all;
            cursor: pointer;
        }
    }

}
</style>
